var viewer_rtlignore_default = {
  "gallery_container": "JRk4e",
  "imageTitleContainer": "x0Vec",
  "clickableItem": "B-g7l",
  "prerender": "bxoLF",
  "expandContainer": "gv-56",
  "expandIcon": "JNOIv",
  "itemOverlay": "_7-Qm7",
  "imageTitle": "rqXZ1",
  "pointer": "oE6-A",
  "fadeIn": "T5M-b",
  "changing_background": "c77s5"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
